"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextualMenu_1 = require("office-ui-fabric-react/lib/ContextualMenu");
var DashboardActions_1 = require("@twii/bored/lib/DashboardActions");
var onAddDashboardClick = function (e, item) {
    DashboardActions_1.addDashboard({ dashboardList: item.dashboardList });
};
var onDashboardClick = function (e, item) {
    item.dashboardList.setActive(item.dashboard);
};
var onRemoveAllDashboardsClick = function (e, item) {
    DashboardActions_1.removeDashboard({ dashboardList: item.dashboardList });
};
var onClickCopyItem = function (e, item) {
    DashboardActions_1.addDashboard({ dashboardList: item.dashboardList, existing: item.dashboard });
};
var onClickRemoveItem = function (e, item) {
    DashboardActions_1.removeDashboard({ dashboardList: item.dashboardList, dashboard: item.dashboard });
};
var createMenuItems = function (dashboardList) {
    var items = [];
    var dashboards = dashboardList.dashboards;
    var active = dashboardList.active;
    if (dashboards.length > 0) {
        var dashboardItems = dashboards.map(function (d) {
            return {
                key: d.id,
                name: d.title,
                canCheck: true,
                checked: d === active,
                dashboardList: dashboardList,
                dashboard: d,
                onClick: onDashboardClick,
                split: true,
                subMenuProps: {
                    items: [
                        {
                            key: "copy",
                            name: "Copy",
                            iconProps: { iconName: "Copy" },
                            dashboardList: dashboardList,
                            dashboard: d,
                            onClick: onClickCopyItem
                        },
                        {
                            key: "remove",
                            name: "Remove",
                            iconProps: { iconName: "ChromeClose" },
                            dashboardList: dashboardList,
                            dashboard: d,
                            onClick: onClickRemoveItem
                        }
                    ]
                }
            };
        });
        var dashboardSectionItem = {
            key: "dashboardSectionItem",
            itemType: ContextualMenu_1.ContextualMenuItemType.Section,
            sectionProps: {
                key: "dashboardSection",
                title: "Dashboards",
                items: dashboardItems
            }
        };
        items.push(dashboardSectionItem);
    }
    var actionItems = [];
    actionItems.push({
        key: "add",
        name: "Add Dashboard",
        dashboardList: dashboardList,
        onClick: onAddDashboardClick,
        iconProps: { iconName: "Add" },
        disabled: dashboardList.sync.syncing
    });
    if (dashboardList.dashboards.length > 0) {
        actionItems.push({
            key: "removeAllSep",
            name: "-"
        });
        actionItems.push({
            key: "removeAll",
            name: "Remove All Dashboards",
            dashboardList: dashboardList,
            onClick: onRemoveAllDashboardsClick,
            iconProps: { iconName: "Clear" }
        });
    }
    var actionSectionItem = {
        key: "actionSectionItem",
        itemType: ContextualMenu_1.ContextualMenuItemType.Section,
        sectionProps: {
            key: "actionSection",
            title: "Actions",
            items: actionItems,
            topDivider: true
        }
    };
    items.push(actionSectionItem);
    return items;
};
exports.createMenuItems = createMenuItems;
var createCommandBarMenuItem = function (dashboardList) {
    var sync = dashboardList.sync;
    var active = dashboardList.active;
    var title = sync.syncing ? "Loading Dashboards..." : sync.error ? "Error" : active ? active.title : "Dashboards";
    return {
        key: "dashboardsCommbarBarItem",
        name: title,
        subMenuProps: {
            items: createMenuItems(dashboardList)
        }
    };
};
exports.createCommandBarMenuItem = createCommandBarMenuItem;
